import React from 'react';

function AccCreateByEmailPage() {
    return <div>AccCreatePassPage</div>;
}

export default AccCreateByEmailPage;
